import React from 'react'
import PropTypes from 'prop-types'
import {Box, SimpleGrid, Text, useMultiStyleConfig} from '@chakra-ui/react'
import SanitizedHtml from '../../html-sanitizer'

const mapColor = {
    White: 'white',
    Grey: 'grey',
    Black: 'black',
}

const TextGroup = ({title, description, color, titleAs = 'div'}) => {
    const styles = useMultiStyleConfig('TextGroup', {
        variant: mapColor[color],
    })

    return (
        <Box data-cs-label="editorial-text_group" {...styles.container}>
            <SimpleGrid {...styles.content}>
                {title && (
                    <Text as={titleAs} {...styles.title}>
                        {title}
                    </Text>
                )}
                {description && (
                    <SanitizedHtml as={Box} html={description} {...styles.description} />
                )}
            </SimpleGrid>
        </Box>
    )
}

TextGroup.displayName = 'TextGroup'

TextGroup.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    color: PropTypes.oneOf(['Black', 'White', 'Grey']),
    titleAs: PropTypes.string,
}

export default TextGroup
